module.exports = __webpack_public_path__ + "static/media/company-twelv.d2c29d30.jpg";